
import { Notification } from 'rsuite';


class CepService{

  async find(cep){
    try{
      const response = await fetch(`https://brasilapi.com.br/api/cep/v1/${cep}`, {
        method: "GET",
      });
      const json = await response.json();

      const output =  {
          zipcode: cep,
          logradouro: json.street || "", 
          localidade: json.city || "", 
          bairro: json.neighborhood || "",  
          uf: json?.state
      }
      if(json.error){
        return false;
      }

      return output;
    }catch(e){
      return {
        erro: "Failed to find cep"
      };
    }
  }

}

export default CepService;